import { createAction, props } from '@ngrx/store';

import type { User, UserCounts } from '../../models/user';

export const checkProjectsExistence = createAction('[User] Check Projects Existence');
export const checkProjectsExistenceSuccess = createAction('[User] Check Projects Existence Success', props<{ hasProjects: boolean }>());
export const setCurrentUser = createAction('[User] Set Current User', props<{ user: User }>());
export const setUserCounts = createAction('[User] Get User Counts');
export const setAdminUserCounts = createAction(
  '[User] Set Admin User Counts',
  props<{ adminUserCounts: { filtered: number; all: number } }>(),
);
export const setUserCountsSuccess = createAction('[User] Get User Counts Success', props<{ counts: UserCounts }>());
export const updateUserCounts = createAction('[User] Update User Counts', props<{ countName: keyof UserCounts; countValue: number }>());
